import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL;

const segmentAPI = axios.create({
  baseURL: `${API_BASE}/api/segments`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Get all segments
export const getSegments = async (authToken, filters = {}) => {
  return segmentAPI.get("/", {
    params: filters,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// Get single segment by ID
export const getSegmentById = async (authToken, segmentId) => {
  return segmentAPI.get(`/${segmentId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// Create new segment
export const createSegment = async (authToken, segmentData) => {
  return segmentAPI.post("/", segmentData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// Update segment
export const updateSegment = async (authToken, segmentId, segmentData) => {
  return segmentAPI.put(`/${segmentId}`, segmentData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// Delete segment
export const deleteSegment = async (authToken, segmentId) => {
  return segmentAPI.delete(`/${segmentId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// Upload contacts from CSV
export const uploadContacts = async (authToken, segmentId, csvFile) => {
  const formData = new FormData();
  formData.append("csvFile", csvFile);

  return segmentAPI.post(`/${segmentId}/contacts/upload`, formData, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

// Get contacts for a segment
export const getContacts = async (authToken, segmentId, filters = {}) => {
  return segmentAPI.get(`/${segmentId}/contacts`, {
    params: filters,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

// Delete contact
export const deleteContact = async (authToken, segmentId, contactId) => {
  return segmentAPI.delete(`/${segmentId}/contacts/${contactId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export default segmentAPI;

